/* eslint-disable */
import { transform } from 'ol/proj';

import OlStyle, { StyleFunction } from 'ol/style/Style';
import { StyleLike } from 'ol/style/Style';
import OlStroke from 'ol/style/Stroke';
import OlCircle from 'ol/style/Circle';
import OlFill from 'ol/style/Fill';
import OlIcon from 'ol/style/Icon';
import OlText from 'ol/style/Text';
import OlRegularShape from 'ol/style/RegularShape';
import OlGeomCircle from 'ol/geom/Circle';

import OlGeomMultiPoint from 'ol/geom/MultiPoint';
import OlGeomPoint from 'ol/geom/Point';
import OlGeomPolygon from 'ol/geom/Polygon';
import OlGeomLineString from 'ol/geom/LineString';

import { calcAngle, formatArea, formatLength } from '@/lib/olHelpers';
import { Feature } from 'ol';
import { FeatureLike } from 'ol/Feature';

export {
  drawStyle,
  measurementsStyle,
  measuringStyle,
  recordStyle,
  selectedStyle,
  workingStyle,
  hoveringStyle,
  geoLocateStyle,
  drawingRouteStyle,
  drawRouteStyle,
  routeStyle,
  routePointStyle,
  commentsStyle,
  commentingStyle,
  blueStroke,
  greenStrokeDashed,
  redStrokeDashed,
  purpleDot,
  highlightedVectorStyle,
  fadeOutHighlightedStyle,
  elevationStyle,
  blackOutlineStyle,
  highlightedVectorCustom,
  selectedStrokeOnlyStyle,
  vertexHandleStyle,
  vertexHandleSelectedStyle,
  getStyleByName
};

const recordStyle = () => {
  const style = new OlStyle({
    image: new OlCircle({
      radius: 7,
      stroke: new OlStroke({
        color: 'rgba(255, 255, 255, 0.79)',
      }),
      fill: new OlFill({
        color: 'rgba(31,154,255, 0.79)',
      }),
    }),
    fill: new OlFill({
      color: 'rgba(184, 184, 184, 0.4)',
    }),
    stroke: new OlStroke({
      color: '#ff1f1f',
      width: 3.25,
    }),
  });
  return style;
};

const selectedStyle = () => {
  let highlightColor = 'rgba(31,154,255, 0.79)';

  const style = new OlStyle({
    image: new OlCircle({
      radius: 7,
      stroke: new OlStroke({
        color: 'rgba(255, 255, 255, 0.79)',
      }),
      fill: new OlFill({
        color: highlightColor,
      }),
    }),
    fill: new OlFill({
      color: 'rgba(184, 184, 184, 0.4)',
    }),
    stroke: new OlStroke({
      color: highlightColor,
      width: 3.25,
    }),
  });
  return style;
};

const selectedStrokeOnlyStyle = () => {
  const highlightColor = '#1f9affc9'
  // const highlightColor = '#ff00f2d8';
  const borderColor = '#179affff'
  // const borderColor = '#f700ffff';

  const outerCircle = new OlStyle({
    image: new OlCircle({
      radius: 15,
      stroke: new OlStroke({
        color: borderColor,
        width: 2,
      }),
      fill: new OlFill({
        color: 'rgba(0,0,0,0)',
      }),
    }),
  });

  const innerCircle = new OlStyle({
    stroke: new OlStroke({
      color: highlightColor,
      width: 3.5,
    }),
    image: new OlCircle({
      radius: 7,
      stroke: new OlStroke({
        color: 'rgba(255,255,255,0.7)',
        width: 1,
      }),
      fill: new OlFill({
        color: highlightColor,
      }),
    }),
    fill: new OlFill({
      color: 'rgba(255,182,193,0.3)',
    }),
  });
  return [outerCircle, innerCircle];
};

const workingStyle = () =>
  new OlStyle({
    image: new OlCircle({
      radius: 15,
      stroke: new OlStroke({
        color: '#FF00FF',
        width: 3.25,
      }),
    }),
    stroke: new OlStroke({
      color: '#FF00FF',
      width: 3.25,
    }),
    fill: new OlFill({
      color: 'rgba(255, 0, 255, 0.2)',
    }),
  });

const hoveringStyle = (f: any) => {
  const id = f.getId();
  const iid = id ? (typeof id === 'string' ? parseInt(id, 10) : id) : 0;
  const label = id ? (iid % 1000000).toString() : '?';
  return new OlStyle({
    image: new OlCircle({
      radius: 15,
      stroke: new OlStroke({
        color: '#feb24c',
        width: 3.25,
      }),
    }),
    stroke: new OlStroke({
      color: '#feb24c',
      width: 3.25,
    }),
    text: new OlText({
      text: label,
      overflow: true,
      fill: new OlFill({ color: '#000' }),
      stroke: new OlStroke({
        color: '#fff',
        width: 8,
      }),
    }),
  });
};

const drawStyle = new OlStyle({
  image: new OlCircle({
    radius: 7,
    stroke: new OlStroke({
      color: 'rgba(255, 255, 255, 0.79)',
    }),
    fill: new OlFill({
      color: 'rgba(31,154,255, 0.79)',
    }),
  }),
  fill: new OlFill({
    color: 'rgba(255,255,255,0.4)',
  }),
  stroke: new OlStroke({
    color: 'rgb(31,154,255)',
    width: 3.25,
  }),
});

const measuringStyle = new OlStyle({
  fill: new OlFill({
    color: 'rgba(255, 255, 255, 0.2)',
  }),
  stroke: new OlStroke({
    color: 'rgba(0, 0, 0, 0.5)',
    lineDash: [10, 10],
    width: 4,
  }),
  image: new OlCircle({
    radius: 5,
    stroke: new OlStroke({
      color: 'rgba(0, 0, 0, 0.5)',
      width: 4,
    }),
    fill: new OlFill({
      color: 'rgba(255, 255, 255, 0.2)',
    }),
  }),
});

// @Piero
// not sure what f is at the moment (maybe layer)
const measurementsStyle = (f: any, coordSys: number) => {
  const geom = f.getGeometry();

  let output;
  let tooltipCoord;

  let extraGeom; // optional extra geometry (like the line from center)

  if (geom instanceof OlGeomPolygon) {
    output = formatArea(geom);
    // tooltipCoord = geom.getInteriorPoint().getCoordinates();
    // tooltipCoord = geom.getCoordinates()[0];
  } else if (geom instanceof OlGeomLineString) {
    output = formatLength(geom);
    // tooltipCoord = geom.getCoordinates()[0];
  } else if (geom instanceof OlGeomPoint) {
    const coords = transform(geom.getCoordinates(), 'EPSG:3857', 'EPSG:' + coordSys);

    const isGeographic = coordSys === 4326;

    // If target CRS is geographic, interpret as [lon, lat] and display φ (lat) and λ (lon)
    if (isGeographic) {
      const lambda = coords[0];
      const phi = coords[1];
      output = `φ: ${phi.toFixed(6)}°, λ: ${lambda.toFixed(6)}°`;
    } else {
      output = `N: ${coords[0].toFixed(2)}, E: ${coords[1].toFixed(2)}`;
    }
    // tooltipCoord = geom;
  } else if (geom instanceof OlGeomCircle) {
    const center = geom.getCenter();
    const radius = geom.getRadius();

    // Line from center to right edge
    const end = [center[0] + radius, center[1]];
    extraGeom = new OlGeomLineString([center, end]);

    // Use geodesic length (like formatLength) instead of raw Euclidean distance in
    // map projection units, which are stretched vs. true ground distance away from
    // the equator (e.g. Web Mercator).
    output = formatLength(extraGeom);

    // tooltipCoord = end; // place tooltip at end of line
  }

  const style = [
    new OlStyle({
      image: new OlCircle({
        radius: 5,
        stroke: new OlStroke({
          color: '#232f34',
          width: 4,
        }),
        fill: new OlFill({
          color: 'rgba(255, 255, 255, 0.2)',
        }),
      }),
    }),
    new OlStyle({
      fill: new OlFill({
        color: 'rgba(255, 255, 255, 0.5)',
      }),
      stroke: new OlStroke({
        color: '#232f34',
        lineDash: [10, 10],
        width: 4,
      }),
    }),
    new OlStyle({
      text: new OlText({
        font: '12px sans serif',
        fill: new OlFill({ color: '#000' }),
        stroke: new OlStroke({ color: '#fff', width: 8 }),
        text: output,
        textBaseline: 'middle',
        offsetY: -12,
      }),
    }),
    ...(extraGeom
      ? [
          new OlStyle({
            stroke: new OlStroke({
              color: '#232f34',
              width: 2,
            }),
            geometry: extraGeom,
          }),
        ]
      : []),
    // ,
    // new OlStyle({
    //   image: new OlCircle({
    //     radius: 3,
    //     stroke: new OlStroke({
    //       color: "#232f34"
    //     }),
    //     fill: new OlFill({
    //       color: "rgba(255, 255, 255, 0.2)"
    //     })
    //   }),
    //   geometry: function (feature) {
    //     // return the coordinates of the first ring of the polygon
    //     const geom = feature.getGeometry();
    //     const type = geom.getType();
    //     var coordinates = geom.getCoordinates
    //       ? type === "Polygon"
    //         ? geom.getCoordinates()[0]
    //         : geom.getCoordinates()
    //       : null;
    //     return coordinates ? new OlGeomMultiPoint(coordinates) : null;
    //   }
    // })
  ];
  return style;
};

const geoLocateStyle = new OlStyle({
  image: new OlCircle({
    radius: 6,
    fill: new OlFill({
      color: 'rgb(31,154,255)',
    }),
    stroke: new OlStroke({
      color: '#fff',
      width: 2,
    }),
  }),
});

const drawingRouteStyle = (f: any) => {
  const color = 'rgba(255, 0, 255, 0.8)';
  const fillColor = 'rgba(255,0,255, 0.5)';

  const pointStyle = new OlStyle({
    image: new OlCircle({
      radius: 6,
      stroke: new OlStroke({
        color,
        width: 4,
      }),
    }),
  });

  const lineStyle = new OlStyle({
    fill: new OlFill({
      color: fillColor,
    }),
    stroke: new OlStroke({
      color,
      lineDash: [15, 15],
      width: 4,
    }),
  });

  const pointsOnLineStyle = new OlStyle({
    image: new OlCircle({
      radius: 6,
      stroke: new OlStroke({
        color,
        width: 4,
      }),
    }),
    geometry(feature) {
      // return the coordinates of the first ring of the polygon
      const geom = feature.getGeometry();
      if (geom && geom instanceof OlGeomLineString) {
        const coordinates = geom.getCoordinates();
        // coordinates.shift(); //remove first
        // coordinates.pop(); //remove last
        return new OlGeomMultiPoint(coordinates);
      }
      return undefined;
    },
  });

  return [pointStyle, lineStyle, pointsOnLineStyle];
};

const drawRouteStyle = (f: any) => {
  const geom = f.getGeometry();
  const coords = geom.getCoordinates();
  const p1 = coords.length > 0 ? coords[0] : null;
  const p2 = coords.length >= 2 ? coords[1] : null;

  const color = 'rgba(255, 0, 255, 0.8)';
  const fillColor = 'rgba(255,0,255, 0.5)';

  const pointStyle = new OlStyle({
    image: new OlCircle({
      radius: 6,
      stroke: new OlStroke({
        color,
        width: 4,
      }),
    }),
  });

  const lineStyle = new OlStyle({
    fill: new OlFill({
      color: fillColor,
    }),
    stroke: new OlStroke({
      color,
      lineDash: [15, 15],
      lineDashOffset: 15,
      width: 4,
    }),
  });

  const pointsOnLineStyle = new OlStyle({
    image: new OlCircle({
      radius: 6,
      stroke: new OlStroke({
        color,
        width: 4,
      }),
    }),
    geometry(feature) {
      // return the coordinates of the first ring of the polygon
      const geom = feature.getGeometry();
      if (geom && geom instanceof OlGeomLineString) {
        const coordinates = geom.getCoordinates();
        coordinates.shift(); // remove first
        // coordinates.pop(); //remove last
        return new OlGeomMultiPoint(coordinates);
      }
      return undefined;
    },
  });

  const firstPointOnLineStyle = new OlStyle({
    image: new OlRegularShape({
      points: 3,
      radius: 16,
      stroke: new OlStroke({
        color,
        width: 4,
      }),
      rotation: calcAngle(p1, p2),
      rotateWithView: true,
    }),
    geometry(feature) {
      // return the coordinates of the first ring of the polygon
      const geom = feature.getGeometry();
      if (geom && geom instanceof OlGeomLineString) {
        const coordinates = geom.getCoordinates();
        return coordinates.length > 0 ? new OlGeomPoint(coordinates[0]) : undefined;
      }
      return undefined;
    },
  });

  const lastPointOnLineStyle = new OlStyle({
    image: new OlCircle({
      radius: 14,
      stroke: new OlStroke({
        color,
        width: 4,
      }),
    }),
    geometry(feature) {
      // return the coordinates of the first ring of the polygon
      const geom = feature.getGeometry();
      if (geom && geom instanceof OlGeomLineString) {
        const coordinates = geom.getCoordinates();
        return coordinates.length > 0 ? new OlGeomPoint(coordinates[coordinates.length - 1]) : undefined;
      }
      return undefined;
    },
  });

  return [pointStyle, lineStyle, firstPointOnLineStyle, pointsOnLineStyle, lastPointOnLineStyle];
};

const routeStyle = (f: any) => {
  const code = f.get('code');
  const color = code === 'A' ? '#ff00FF' : code === 'B' ? '#0000FF' : code === 'C' ? '#00FF00' : '#ff1f1f';
  const outer = new OlStyle({
    stroke: new OlStroke({
      color: 'rgba(255,0,0,0.8)',
      width: 9,
    }),
  });
  const inner = new OlStyle({
    stroke: new OlStroke({
      color: 'rgba(255,255,255,1)',
      width: 3,
    }),
  });
  return [outer, inner];
};

const routePointStyle = (f: any) => {
  const color = 'rgba(255,0,0,0.8)';
  return new OlStyle({
    image: new OlCircle({
      radius: 6,
      stroke: new OlStroke({
        color,
        width: 4,
      }),
      fill: new OlFill({
        color: 'rgba(255,255,255,1)',
      }),
    }),
  });
};

const commentingStyle = new OlStyle({
  fill: new OlFill({
    color: 'rgba(255, 255, 255, 0.2)',
  }),
  stroke: new OlStroke({
    color: 'rgba(56, 142, 60, 0.5)',
    lineDash: [10, 10],
    width: 4,
  }),
  image: new OlCircle({
    radius: 5,
    stroke: new OlStroke({
      color: 'rgba(56, 142, 60, 0.5)',
      width: 4,
    }),
    fill: new OlFill({
      color: 'rgba(255, 255, 255, 0.2)',
    }),
  }),
});

const commentsStyle = (f: any) => {
  const geom = f.getGeometry();
  let output;
  let tooltipCoord;

  if (geom instanceof OlGeomPolygon) {
    output = formatArea(geom);
    // tooltipCoord = geom.getInteriorPoint().getCoordinates();
    tooltipCoord = geom.getCoordinates()[0];
  } else if (geom instanceof OlGeomLineString) {
    output = formatLength(geom);
    tooltipCoord = geom.getCoordinates()[0];
  } else if (geom instanceof OlGeomPoint) {
    const htrs_array = transform(geom.getCoordinates(), 'EPSG:3857', 'EPSG:3765');
    output = `X: ${htrs_array[0].toFixed(0)}, Y:${htrs_array[1].toFixed(0)}`;
    tooltipCoord = geom;
  }
  const style = [
    new OlStyle({
      image: new OlCircle({
        radius: 5,
        stroke: new OlStroke({
          color: '#388e3c',
          width: 4,
        }),
        fill: new OlFill({
          color: 'rgba(255, 255, 255, 0.2)',
        }),
      }),
    }),
    new OlStyle({
      fill: new OlFill({
        color: 'rgba(255, 255, 255, 0.5)',
      }),
      stroke: new OlStroke({
        color: '#388e3c',
        // lineDash: [10, 10],
        width: 4,
      }),
    }),
    // new OlStyle({
    //   text: new OlText({
    //     font: "12px sans serif",
    //     fill: new OlFill({ color: "#000" }),
    //     stroke: new OlStroke({color: "#fff", width: 8}),
    //     text: output,
    //     textBaseline: "middle",
    //     offsetY: -12
    //   })
    // })

    // ,
    // new OlStyle({
    //   image: new OlCircle({
    //     radius: 3,
    //     stroke: new OlStroke({
    //       color: "#232f34"
    //     }),
    //     fill: new OlFill({
    //       color: "rgba(255, 255, 255, 0.2)"
    //     })
    //   }),
    //   geometry: function (feature) {
    //     // return the coordinates of the first ring of the polygon
    //     const geom = feature.getGeometry();
    //     const type = geom.getType();
    //     var coordinates = geom.getCoordinates
    //       ? type === "Polygon"
    //         ? geom.getCoordinates()[0]
    //         : geom.getCoordinates()
    //       : null;
    //     return coordinates ? new OlGeomMultiPoint(coordinates) : null;
    //   }
    // })
  ];
  return style;
};

const blueStroke = () => {
  const style = new OlStyle({
    stroke: new OlStroke({
      color: 'rgb(31,154,255)',
      width: 3.25,
    }),
  });
  return style;
};

const redStrokeDashed = () => {
  const style = new OlStyle({
    stroke: new OlStroke({
      color: '#f42e2e',
      width: 3.25,
      lineDash: [10, 10],
    }),
  });
  return style;
};

const greenStrokeDashed = () => {
  const style = new OlStyle({
    stroke: new OlStroke({
      color: '#32cf19',
      width: 3.25,
      lineDash: [15, 15],
    }),
  });
  return style;
};

const purpleDot = () => {
  const style = new OlStyle({
    image: new OlCircle({
      radius: 5,
      stroke: new OlStroke({
        color: '#cf30ff',
        width: 4,
      }),
      fill: new OlFill({
        color: '#cf30ff',
      }),
    }),
  });
  return style;
};

const highlightedVectorStyle = (feature: FeatureLike) => {
  const type = feature && feature.get ? feature.get('type') : undefined;

  if (type !== 'secondary') {
    // Magenta fill + stroke
    return new OlStyle({
      image: new OlCircle({
        radius: 20,
        stroke: new OlStroke({
          color: '#FF00FF',
          width: 3.25,
        }),
        fill: new OlFill({
          color: 'rgba(255, 0, 255, 0.2)',
        }),
      }),
      stroke: new OlStroke({
        color: '#FF00FF',
        width: 3.25,
      }),
      fill: new OlFill({
        color: 'rgba(255, 0, 255, 0.2)',
      }),
    });
  } else {
    // Cyan outline only (no fill)
    return new OlStyle({
      image: new OlCircle({
        radius: 20,
        stroke: new OlStroke({
          color: '#00FFFF',
          width: 3.25,
        }),
      }),
      stroke: new OlStroke({
        color: '#00FFFF',
        width: 3.25,
      }),
    });
  }
};

const highlightedVectorCustom = () =>
  new OlStyle({
    image: new OlCircle({
      radius: 5,
      stroke: new OlStroke({
        color: '#FF00FF',
        width: 1,
      }),
      fill: new OlFill({
        color: '#FF00FF',
      }),
    }),
    stroke: new OlStroke({
      color: '#FF00FF',
      width: 1,
    }),
    fill: new OlFill({
      color: '#FF00FF',
    }),
  });

const vertexHandleStyle = () =>
  new OlStyle({
    image: new OlCircle({
      radius: 5,
      fill: new OlFill({ color: "#ffffff" }),
      stroke: new OlStroke({ color: "#e53935", width: 2 }),
    }),
  });

const vertexHandleSelectedStyle = () =>
  new OlStyle({
    image: new OlCircle({
      radius: 6,
      fill: new OlFill({ color: "#fff7f7" }),
      stroke: new OlStroke({ color: "#c62828", width: 3 }),
    }),
  });

const fadeOutHighlightedStyle = (opacity: number, setStyleFn: any) => {
  setStyleFn(
    new OlStyle({
      image: new OlCircle({
        radius: 20,
        stroke: new OlStroke({
          color: `rgba(0, 28, 255, 1)`, // #001cff
          width: 5,
        }),
        fill: new OlFill({
          color: `rgba(21, 252, 235, ${opacity})`, // #15fceb
        }),
      }),
      stroke: new OlStroke({
        color: `rgba(0, 28, 255, 1)`,
        width: 5,
      }),
      fill: new OlFill({
        color: `rgba(21, 252, 235, ${opacity})`,
      }),
    })
  );

  if (opacity > 0.03)
    setTimeout(() => {
      fadeOutHighlightedStyle(opacity - 0.03, setStyleFn);
    }, 1);
  else if (opacity > 0)
    setTimeout(() => {
      fadeOutHighlightedStyle(0, setStyleFn);
    }, 1);
};

const elevationStyle = (f: any) => {
  const alt = f.get('alt');
  const dh = f.get('dh');

  const dhValid = dh && !isNaN(parseFloat(dh));

  const lbl = 'Alt: ' + alt + ' m' + (dhValid ? ', Δh: ' + dh + ' m' : '');
  return (
    new OlStyle({
      image: new OlCircle({
        radius: 5,
        stroke: new OlStroke({
          color: 'rgba(0, 0, 0, 0.8)',
          width: 4,
        }),
        fill: new OlFill({
          color: 'rgba(255, 255, 255, 0.2)',
        }),
      }),
    }),
    new OlStyle({
      text: new OlText({
        font: '12px sans serif',
        backgroundFill: new OlFill({ color: '#FFF' }),
        // backgroundStroke: new OlStroke({
        //   color: "#F00",
        //   width: 3
        // }),
        padding: [2, 2, 0, 5],
        text: lbl,
        textBaseline: 'middle',
        offsetY: 16,
      }),
    })
  );
};

const blackOutlineStyle = (f: any) => {
  const style = [
    new OlStyle({
      fill: new OlFill({
        color: 'rgba(255, 255, 255, 0)',
      }),
      stroke: new OlStroke({
        color: '#000000',
        width: 4,
      }),
    }),
  ];
  return style;
};

// openlayers equivalent for sld style above
/*const dkpStyle: StyleFunction = (feature: FeatureLike) => new OlStyle({
  stroke: new OlStroke({ color: '#e3bf0e', width: 1, lineJoin: 'bevel' }),
  text: new OlText({
    font: '13px Roboto',
    fill: new OlFill({ color: '#000' }),
    stroke: new OlStroke({ color: '#e3bf0e', width: 3 }),
    text: String(feature.get('kc_broj') ?? ''),
  }),
  fill: new OlFill({
    color: 'rgba(227, 191, 14, 0.01)',
  }),
});*/

function hexToRgba(hex: string, opacity: number): string {
  const r = parseInt(hex.slice(1, 3), 16)
  const g = parseInt(hex.slice(3, 5), 16)
  const b = parseInt(hex.slice(5, 7), 16)
  return `rgba(${r},${g},${b},${opacity})`
}

export function plinovodiStyle(f: FeatureLike, resolution: number): OlStyle[] {
  const styles: OlStyle[] = []

  // PE
  if ((f.get("materijal") === "PE")) {
    styles.push(
      new OlStyle({
        stroke: new OlStroke({ color: "#FF0", width: 3 }),
      })
    )
  }

  // PE label
  if ((f.get("materijal") === "PE" &&
  !(f.get("promjer") === null)) && resolution < 3000 / 3779.5275) {
    styles.push(
      new OlStyle({
        text: new OlText({
          text: String(f.get("promjer") ?? ''),
          font: "bold 12px Arial",
          fill: new OlFill({ color: "#FFFF00" }),
          stroke: new OlStroke({ color: hexToRgba("#333333", 0.85), width: 2 }),
          placement: "line",
        }),
      })
    )
  }

  // PVC
  if ((f.get("materijal") === "PVC")) {
    styles.push(
      new OlStyle({
        stroke: new OlStroke({ color: "#00F", width: 3 }),
      })
    )
  }

  // PVC label
  if ((f.get("materijal") === "PVC" &&
  !(f.get("promjer") === null)) && resolution < 3000 / 3779.5275) {
    styles.push(
      new OlStyle({
        text: new OlText({
          text: String(f.get("promjer") ?? ''),
          font: "bold 12px Arial",
          fill: new OlFill({ color: "#0000FF" }),
          stroke: new OlStroke({ color: hexToRgba("#ffffff", 0.85), width: 2 }),
          placement: "line",
        }),
      })
    )
  }

  // CE
  if ((f.get("materijal") === "CE")) {
    styles.push(
      new OlStyle({
        stroke: new OlStroke({ color: "#F00", width: 3 }),
      })
    )
  }

  // CE label
  if ((f.get("materijal") === "CE" &&
  !(f.get("promjer") === null)) && resolution < 3000 / 3779.5275) {
    styles.push(
      new OlStyle({
        text: new OlText({
          text: String(f.get("promjer") ?? ''),
          font: "bold 12px Arial",
          fill: new OlFill({ color: "#FF0000" }),
          stroke: new OlStroke({ color: hexToRgba("#ffffff", 0.85), width: 2 }),
          placement: "line",
        }),
      })
    )
  }

  // Nepoznato
  if ((f.get("materijal") === null)) {
    styles.push(
      new OlStyle({
        stroke: new OlStroke({ color: "#800080", width: 3 }),
      })
    )
  }

  // Nepoznato label
  if ((f.get("materijal") === null &&
  !(f.get("promjer") === null)) && resolution < 3000 / 3779.5275) {
    styles.push(
      new OlStyle({
        text: new OlText({
          text: String(f.get("promjer") ?? ''),
          font: "bold 12px Arial",
          fill: new OlFill({ color: "#800080" }),
          stroke: new OlStroke({ color: hexToRgba("#ffffff", 0.85), width: 2 }),
          placement: "line",
        }),
      })
    )
  }

  return styles
}

export function dkpStyle(f: FeatureLike, resolution: number): OlStyle[] {
  const styles: OlStyle[] = []

  if (resolution < 3000 / 3571.4214) {
    styles.push(
      new OlStyle({
        stroke: new OlStroke({ color: "#e3bf0e", width: 1 }),
        fill: new OlFill({
          color: 'rgba(227, 191, 14, 0.01)',
        }),
      })
    )
  }

  if (resolution < 2000 / 3571.4214) {
    styles.push(
      new OlStyle({
        text: new OlText({
          text: String(f.get("kc_broj") ?? ''),
          font: "normal normal 12px Trebuchet MS",
          fill: new OlFill({ color: "#000000" }),
          stroke: new OlStroke({ color: "#e3bf0e", width: 2 }),
          placement: "point",
          offsetX: 0,
          offsetY: 0,
        }),
      })
    )
  }

  return styles
}

const getStyleByName = (name?: string): StyleLike | undefined => {
  switch (name) {
    case 'dkp': 
      return dkpStyle;
    case 'plinovodi':
      return plinovodiStyle;
    default:
      return undefined;
  }
}